import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useApiClient from 'hooks/use-api-client';

// Not organization-scoped, unlike its neighbours: an org switch mid-session is not a preference change.
export const userPreferencesCacheKey = ['user-preferences'] as const;

export const useGetUserPreferences = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: userPreferencesCacheKey,
    queryFn: apiClient.accounts.getUserPreferences,
    enabled
  });
};

export const useUpdateUserPreferences = () => {
  const apiClient = useApiClient();
  // The client from context, not the module singleton its neighbours reach for: they are the same
  // object in the app, but only this one is the client the component tree actually reads from.
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: apiClient.accounts.updateUserPreferences,
    // The PUT response is the row it wrote, so it replaces the cache outright - no refetch.
    onSuccess: preferences => {
      queryClient.setQueryData(userPreferencesCacheKey, preferences);
    }
  });
};
